import styled, { css } from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { getSelectControlStyles } from '../../Select/helpers/getSelectControlStyles';

const triggerFocusStyles = css<{
    $positive?: boolean;
    $negative?: boolean;
}>`
    box-shadow: ${(props) =>
        getSelectControlStyles(
            { isFocused: true, menuIsOpen: false, isDisabled: false },
            {
                positive: props.$positive,
                negative: props.$negative,
            }
        ).boxShadow};
`;

const triggerHoverStyles = css<{
    $isOpen: boolean;
    $disabled?: boolean;
    $positive?: boolean;
    $negative?: boolean;
}>`
    box-shadow: ${(props) =>
        getSelectControlStyles(
            { isFocused: false, menuIsOpen: props.$isOpen, isDisabled: props.$disabled },
            {
                positive: props.$positive,
                negative: props.$negative,
            }
        ).hoverBoxShadow};
`;

export const DropdownTriggerControl = styled.div<{
    $isOpen: boolean;
    $disabled?: boolean;
    $positive?: boolean;
    $negative?: boolean;
    $minWidth: string;
    $isMulti?: boolean;
}>`
    align-items: center;
    background: ${(props) =>
        getSelectControlStyles(
            { isFocused: false, menuIsOpen: props.$isOpen, isDisabled: false },
            {
                positive: props.$positive,
                negative: props.$negative,
            }
        ).backgroundColor};
    border: none;
    border-radius: ${theme.radii[6]};
    box-shadow: ${(props) =>
        getSelectControlStyles(
            { isFocused: false, menuIsOpen: props.$isOpen, isDisabled: false },
            {
                positive: props.$positive,
                negative: props.$negative,
            }
        ).boxShadow};
    box-sizing: border-box;
    color: ${theme.colors.foreground.default};
    cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
    display: flex;
    font-size: ${theme.fontSizes[14]};
    font-weight: ${theme.fontWeights[400]};
    gap: ${theme.space[6]};
    height: 32px;
    line-height: 24px;
    margin: 0;
    max-width: 100%;
    min-width: ${(props) => props.$minWidth};
    outline: none;
    padding: ${theme.space[4]} ${theme.space[6]} ${theme.space[4]}
        ${(props) => (props.$isMulti ? theme.space[6] : theme.space[8])};
    text-align: left;
    transition: box-shadow 75ms;
    width: 100%;

    &:hover {
        ${triggerHoverStyles}
    }

    &:hover {
        color: ${(props) => (props.$disabled ? theme.colors.foreground.disabled : theme.colors.foreground.default)};
    }

    &:focus {
        ${triggerFocusStyles}
    }

    ${(props) => (props.$isOpen && !props.$disabled ? triggerFocusStyles : null)}

    &[aria-disabled='true'] {
        background: ${getSelectControlStyles({ isFocused: false, menuIsOpen: false, isDisabled: true }, {})
            .backgroundColor};
        box-shadow: ${getSelectControlStyles({ isFocused: false, menuIsOpen: false, isDisabled: true }, {}).boxShadow};
        color: ${theme.colors.foreground.disabled};
        cursor: default;
    }
`;
